export const addExtraTooltipId = "add-billing-modal-extra-price-id";

export const subExtraTooltipId = "sub-billing-modal-extra-price-id";
